export const CURRENCY = '€';
export const DEV = 'development';
export const PROD = 'production';

export const ADMIN_COOKIE_NAME = 'admin_clubsurfeduca.com';
export const KINDUSER_COOKIE_NAME = 'kind_clubsurfeduca.com';
// Use the canonical host directly for POST requests. The www host redirects
// to this one and some clients lose the request body during that redirect.
export const BASE_WEBSITE_URL = '//clubsurfeduca.com';

export const TAB_WEB_NAME = 'ClubSurfEduca';
